import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CartNotEmptyGuard, CheckoutAuthGuard } from '@spartacus/checkout/base/components';
import { ConfigModule, provideDefaultConfig } from '@spartacus/core';
import { CustomCheckoutB2bGuard } from '../guards/custom-checkout-b2b.guard';
import { ComponentsModule } from './components/components.module';
import {
  OrderConfirmationGuard,
  OrderConfirmationItemsComponent,
  OrderConfirmationShippingComponent,
  OrderConfirmationThankYouMessageComponent,
  OrderConfirmationTotalsComponent,
  OrderDetailBillingComponent,
  OrderDetailsService,
  OrderOverviewComponent,
} from '@spartacus/order/components';
import { OrderFacade } from '@spartacus/order/root';
import { CustomOrderConfirmationGuard } from '@guards/custom-order-confirmation.guard';
import { DIALOG_TYPE, LayoutConfig } from '@spartacus/storefront';
import { ModalPonumberComponent } from './components/modal-ponumber/modal-ponumber.component';

export const CustomModalsConfig: LayoutConfig = {
  launch: {
    MISSING_PO_NUMBER_MODAL: {
      inline: true,
      component: ModalPonumberComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    }
  },
};

@NgModule({
  declarations: [],
  providers: [provideDefaultConfig(CustomModalsConfig)],
  imports: [
    CommonModule,
    ComponentsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CheckoutOrchestrator: {
          component: () =>
            import('./components/checkout-orchestrator/checkout-orchestrator.component').then(
              (m) => m.CheckoutOrchestratorComponent
            ),
          guards: [CheckoutAuthGuard, CartNotEmptyGuard, CustomCheckoutB2bGuard],
        },
        CheckoutOrderSummary: {
          component: () =>
            import('./components/checkout-summary/checkout-summary.component').then(
              (m) => m.CheckoutSummaryComponent
            ),
        },
        OrderConfirmationThankMessageComponent: {
          component: OrderConfirmationThankYouMessageComponent,
          guards: [CustomOrderConfirmationGuard],
        },
        ReplenishmentConfirmationMessageComponent: {
          component: OrderConfirmationThankYouMessageComponent,
          guards: [],
        },

        OrderConfirmationItemsComponent: {
          component: OrderConfirmationItemsComponent,
          guards: [],
        },
        ReplenishmentConfirmationItemsComponent: {
          component: OrderConfirmationItemsComponent,
          guards: [],
        },

        OrderConfirmationTotalsComponent: {
          component: OrderConfirmationTotalsComponent,
          guards: [],
        },
        ReplenishmentConfirmationTotalsComponent: {
          component: OrderConfirmationTotalsComponent,
          guards: [],
        },

        OrderConfirmationOverviewComponent: {
          component: OrderOverviewComponent,
          providers: [
            {
              provide: OrderDetailsService,
              useExisting: OrderFacade,
            },
          ],
          guards: [],
        },
        ReplenishmentConfirmationOverviewComponent: {
          component: OrderOverviewComponent,
          providers: [
            {
              provide: OrderDetailsService,
              useExisting: OrderFacade,
            },
          ],
          guards: [],
        },

        OrderConfirmationShippingComponent: {
          component: OrderConfirmationShippingComponent,
          guards: [],
        },

        OrderConfirmationBillingComponent: {
          component: OrderDetailBillingComponent,
          providers: [
            {
              provide: OrderDetailsService,
              useExisting: OrderFacade,
            },
          ],
          guards: [],
        },
      },
    }),
  ],
})
export class CustomCheckoutModule {}
